import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  Flex,
  Heading,
  Input,
  Stack,
  Text,
} from '@chakra-ui/react';
import { FormControl, FormErrorMessage, FormLabel } from './FormControls';
import { api } from '../api/api';
import { useAuth } from '../context/AuthContext';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState(''), [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{email?:string;password?:string}>({});
  const [serverError, setServerError] = useState('');

  const validate = () => {
    const errs: any = {};
    if (!email) errs.email = 'Email is required';
    else if (!/^\S+@\S+\.\S+$/.test(email)) errs.email = 'Invalid email';
    if (!password) errs.password = 'Password is required';
    else if (password.length < 6) errs.password = 'Must be ≥6 chars';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const { token } = await api.auth.login(email, password);
      login(token);
      navigate('/dashboard');
    } catch (err: any) {
      setServerError(err.response?.data || 'Login failed');
    }
  };

  return (
    <Flex minH="100vh" bg="gray.100" align="center" justify="center" px={4}>
      <Box w="full" maxW="md" shadow="xl" bg="white" borderRadius="xl" p={8}>
          <Stack gap={6}>
            <Box textAlign="center">
              <Heading size="lg" color="brand.600">Key Management Admin</Heading>
              <Text color="gray.500">Sign in to continue</Text>
            </Box>

            {serverError && (
              <Alert.Root status="error" borderRadius="md">
                <Alert.Content>
                  <Alert.Description>{serverError}</Alert.Description>
                </Alert.Content>
              </Alert.Root>
            )}

            <form onSubmit={handleSubmit} noValidate>
              <Stack gap={4}>
                <FormControl isInvalid={!!errors.email}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    placeholder="admin@example.com"
                  />
                  <FormErrorMessage>{errors.email}</FormErrorMessage>
                </FormControl>

                <FormControl isInvalid={!!errors.password}>
                  <FormLabel>Password</FormLabel>
                  <Input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Enter your password"
                  />
                  <FormErrorMessage>{errors.password}</FormErrorMessage>
                </FormControl>

                <Button type="submit" colorPalette="brand" size="lg">
                  Login
                </Button>
              </Stack>
            </form>
          </Stack>
      </Box>
    </Flex>
  );
};

export default LoginPage;
